import { useNode } from '@craftjs/core'
import React from 'react'
import { TextSettings } from './TextSettings'
import { useEffect } from 'react'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {
  text: '<p>Enter your text!</p>',
  noHtml: false,
  anchor_id: '',
}

export const dynamicProps = ['text', 'anchor_id']

export const Text = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { text, noHtml, anchor_id } = blockProps

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect, drag },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode((state) => ({
      selected: state.events.selected,
      dragged: state.events.dragged,
      hovered: state.events.hovered,
      customs: state.data.custom,
    }))

    useEffect(() => {
      const anchor = window.location.hash.substr(1)
      if (anchor) {
        const element = document.getElementById(anchor)
        if (element) {
          var headerOffset = 80
          var elementPosition = element.getBoundingClientRect().top
          var offsetPosition = elementPosition + window.pageYOffset - headerOffset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })
        }
      }
    }, [])

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-text custom-content ' + props.className}
        {...(anchor_id && { id: anchor_id })}
      >
        {children.props.children[0]}
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Text.craft = withCraft({
  name: 'Text',
  defaultProps: defaultProps,
  settings: TextSettings,
})
